import { CommonModule } from '@angular/common';
import { Component, ContentChild, Input, TemplateRef } from '@angular/core';

export interface TableColumn {
  header: string;
  field?: string; // Optional if using template
  width?: string;
  style?: Record<string, string>;
}

@Component({
  selector: 'app-table',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent<T> {
  @Input() columns: TableColumn[] = [];
  @Input() data: T[] = [];
  @Input() loading = false;
  @Input() noResultsMessage = 'No results found.';
  @Input() skeletonRows = 3;

  @ContentChild(TemplateRef) rowTemplate!: TemplateRef<{
    $implicit: T;
    index: number;
  }>;

  get skeletonColumns(): number {
    return this.columns.length;
  }

  get skeletonRowsArray(): number[] {
    return Array(this.skeletonRows).fill(0);
  }
}
